module.exports = __webpack_public_path__ + "static/media/mobile_mockup_2_old2.59cffd69.png";